import React, { useEffect, useState } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import { palette } from '../../../system/styles/styles';

const CompanyModal = ({ data, open, close, className }) => {
  const [state, setState] = useState({
    companyName: '',
    locationName: '',
    data: '',
    companyWebsite: '',
    companyAbout: '',
  });

  useEffect(() => {
    setState({
      companyName: data.companyName,
      locationName: data.locationName,
      data: data.data,
      companyWebsite: formatURL(data.companyWebsite),
      companyAbout: data.companyAbout,
      companyLogo: data.companyLogo,
      adminName: data.adminName !== '' ? data.adminName : '',
      companyLine: data.companyLine !== '' ? data.companyLine : '',
      companyPhone: data.companyPhone !== '' ? data.companyPhone : '',
      companyEmployeesNumber: data.companyEmployeesNumber !== '' ? data.companyEmployeesNumber : 0,
      campusSegment: data.campusSegment !== '' ? data.campusSegment : '',
      companyRFC: data.companyRFC !== '' ? data.companyRFC : '',
      companyAddressProof: data.companyAddressProof !== '' ? data.companyAddressProof : '',
    });
  }, [data]);

  const formatURL = (url) => {
    const n = url.includes('http://');
    const s = url.includes('https://');
    if (url === '') {
      return '';
    } if (n) {
      return url.replace('http://', '');
    } if (s) {
      return url.replace('https://', '');
    } 
      return url;
    
  };

  if (!open) return null;

  return (
    <Dialog onClose={close} title="Conoce más de esta empresa">
      <div className={className}>
        <div className="modalContainer">
          <div className="imageContainer">
            {state.companyLogo === '' ? (
              <img
                src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174"
                alt="company-detail"
              />
            ) : (
              <img src={state.companyLogo} alt="company-detail" />
            )}
          </div>
          <div className="companyDataContainer">
            <p>DATOS GENERALES</p>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p className="modalLabel">Empresa:</p>
              </div>
              <div className="dataArea">
                <p>{state.companyName}</p>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>Administrador:</p>
              </div>
              <div className="dataArea">
                <p>{state.adminName}</p>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>Ubicación:</p>
              </div>
              <div className="dataArea">
                <p>{state.locationName}</p>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>Giro empresarial:</p>
              </div>
              <div className="dataArea">
                <p>{state.companyLine === '' ? 'No requerido' : state.companyLine}</p>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>RFC:</p>
              </div>
              <div className="dataArea">
                <div>
                  {state.companyRFC === '' ? (
                    <span>No requerido</span>
                  ) : (
                    <a href={state.companyRFC} target="_blank" rel="noopener noreferrer external" className="mc-text">
                      Descargar
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>Teléfono:</p>
              </div>
              <div className="dataArea">
                <p>{state.companyPhone}</p>
              </div>
            </div>
            <div className="companyDataContainer">
              <div className="labelsArea">
                <p>Sitio web:</p>
              </div>
              <div className="dataArea">
                <div className="modalLabelData">
                  {state.companyWebsite === '' ? (
                    <p className="mc-text">No disponible</p>
                  ) : (
                    <a href={`http://${state.companyWebsite}`} rel="noopener noreferrer external" target="_blank">
                      Entrar al sitio
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className=""> */}
        {/*  <p className="mc-name">Un poco de historia:</p> */}
        {/*  <ReactQuill className="description" value={state.data} readOnly={true} theme={'bubble'} /> */}
        {/* </div> */}
      </div>
    </Dialog>
  );
};

export default styled(CompanyModal)`
  position: relative;
  width: 70%;
  margin: 10px auto;
  overflow-y: auto;
  height: 85vh;
  background-color: white;
  border: 2px solid #000;
  box-shadow: ${palette.lightBS};
  padding: 16px;
  outline: none;
  .modalContainer {
    display: flex;
    width: 100%;
    padding: 10px;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
  }
  .imageContainer {
    width: 20%;
    padding: 10px;
    display: flex;
    justify-content: center;
    img {
      width: 90%;
      display: block;
    }
  }
  .companyDataContainer {
    width: 100%;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    p {
      width: 100%;
      padding: 5px;
      font-size: 2.8rem;
      text-align: start;
    }
  }
  .labelsArea {
    width: 50%;
    padding: 0px;
    text-align: start;
    font-size: 2.5rem;
    font-weight: bold;
    p {
      margin-bottom: 0px;
      font-size: 2.2rem;
      font-weight: 800;
    }
  }
  .dataArea {
    width: 50%;
    padding: 5px;
    text-align: start;
    font-size: 2.5rem;
    p,
    span {
      margin-bottom: 0px;
      font-size: 2rem !important;
      font-weight: 500;
    }
  }
  .modalLabelData {
    margin-bottom: 0px;
    font-size: 2rem !important;
    font-weight: 500;
    a {
      margin-bottom: 0px;
      font-size: 2rem !important;
      font-weight: 500;
    }
  }
`;
